import React from 'react';
import AppConfig from '../../config/app-config';
import ThankYouSceneView from './thank-you-scene-view';

function ThankYouSceneProvider({ ...props }) {
  return (
    <ThankYouSceneView
      {...AppConfig.Copy.ThankYouPage}
      {...props}
    />
  );
}

export default ThankYouSceneProvider;

